import {
  Show,
  SimpleShowLayout,
  TextField,
  EmailField,
  DateField,
  ReferenceField,
  FunctionField,
} from 'react-admin';

export const InquiryShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="company" />
      <TextField source="phone" />
      <EmailField source="email" />
      <TextField source="comment" />
      
      <ReferenceField source="userId" reference="users" link="show" emptyText="Анонимная заявка">
        <FunctionField render={(record: any) => 
          record ? `${record.firstName || ''} ${record.lastName || ''}`.trim() : ''
        } />
      </ReferenceField>
      
      <TextField source="adminNotes" emptyText="Нет заметок" />
      <TextField source="source" emptyText="-" />
      <TextField source="ipAddress" emptyText="-" />
      <TextField source="userAgent" emptyText="-" />
      
      <DateField source="createdAt" showTime />
      <DateField source="updatedAt" showTime />
    </SimpleShowLayout>
  </Show>
);
